import { ComponentType, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import Europe from "../Components/Europe";
import EuropeSubPage from "../Components/Europe/id";
import FranceGenderEqualityIndex from "../Components/Europe/france_gender_equality_index";

import { EUROPE_SUB_PAGES } from "../Config/Static/ProgramDetail/Europe";

const CUSTOM_PAGE_COMPONENTS: Record<string, ComponentType> = {
  "france-gender-equality-index": FranceGenderEqualityIndex,
};

function EuropeContainer() {
  const navigate = useNavigate();
  const { pageId } = useParams<{ pageId?: string }>();
  const CustomComponent = pageId ? CUSTOM_PAGE_COMPONENTS[pageId] : undefined;

  useEffect(() => {
    if (pageId) {
      const isProgram = EUROPE_SUB_PAGES.some((x) => x.slug === pageId);
      const isCustom = !!CustomComponent;

      if (!isProgram && !isCustom) {
        navigate("/404-found");
      }
    }
  }, [pageId, navigate, CustomComponent]);

  let content;

  if (!pageId) {
    content = <Europe />;
  } else if (CustomComponent) {
    content = <CustomComponent />;
  } else {
    content = <EuropeSubPage pageId={pageId} />;
  }
  return (
    <>
      <Helmet>
        <title>NISSAN MOTOR CORPORATION - GLOBAL CAREER WEBSITE - EUROPE</title>
      </Helmet>
      <main className="americas-container europes-container">{content}</main>
    </>
  );
}

export default EuropeContainer;
